const auth = ({ next, router, to, store }) => {
  let { acessoVerificado, usuario, lembrar } = store.state;

  if (!acessoVerificado && to.path != "/login") {
    return router.push(`/login?redirect_url=${btoa(`${to.path}`)}`);
  }
  if (acessoVerificado) {
    if (lembrar && !usuario.login) {
      return router.push("/login");
    }
    if (lembrar && usuario.login && to.path == "/login") {
      return router.push(`/login/${btoa(usuario.login)}`);
    }
  }

  return next();
};

export default auth;



// WEBPACK FOOTER //
// ./src/middleware/auth.js